import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'reactstrap';
import neoLogoC from "../../../assets/images/Neo_Logo_C.svg";
import { useAuth } from "../../../hooks/useAuth";

const Header = () => {
  const { user } = useAuth();
  
  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 1000,
      padding: '20px 0'
    }}>
      <Container fluid className="px-4 px-xl-5">
        <Row className="align-items-center">
          <Col xs={6}>
            <Link to="/">
              <img 
                src={neoLogoC} 
                alt="NeoApp Logo" 
                height="45" 
                style={{ filter: 'brightness(0) invert(1)' }} // Torna o logo branco para contrastar no fundo escuro
              />
            </Link>
          </Col>
          <Col xs={6} className="text-end">
            <Link to={user ? "/home" : "/login"}>
              <Button outline className="px-4 py-2 rounded-pill fw-bold" style={{
                color: '#fff',
                borderColor: 'rgba(255,255,255,0.7)',
                backgroundColor: 'transparent',
                backdropFilter: 'blur(4px)',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => { e.target.style.backgroundColor = '#fff'; e.target.style.color = '#2a3042'; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#fff'; }}
              >
                {user ? "Acessar Sistema" : "Login"}
              </Button>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Header;
